 
import '../../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../assets/css/style.css';
import React, {useState} from 'react';
import {UserLogin} from '../../Services/User/User'
import UserAuth from '../../lib/userAuth'

async function handleLogin(email, password) {
  const response = await UserLogin(email, password);

  if (response && response.status === 200) {
    const data = await response.json();
    if (data && data.status === true && data.data) {
      const { token, username, permissions } = data.data;
      await localStorage.setItem('username', username);
      await localStorage.setItem('token', token);
      await localStorage.setItem('permissions', JSON.stringify(permissions));
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigateHome = async (event) => {
    event.preventDefault();
    if (validateInputs()) {
      const loggedIn = await handleLogin(username, password);
    if (loggedIn){
      window.location.href = "/home";
    } else {
      alert('Invalid username or password');
    }
    }
  };

  const validateInputs = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(username)) {
      alert('Please enter a valid email.');
      return false;
    }
    const passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$*-.,;]).{8,16}$/;
    if (password.length < 8 && passwordPattern ) {
      alert('Enter valid password');
      return false;
    }

    return true;
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return !UserAuth()? (
    <div className="App">
     <div className="container">

<section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

        <div className="d-flex justify-content-center py-4">
          <a href="/login" className="logo d-flex align-items-center w-auto">
          <img src="https://www.magikmat.com/wp-content/uploads/2023/09/MicrosoftTeams-image-10.png" alt="" />
            <span className="d-none d-lg-block">Magikmat</span>
          </a>
        </div> 

        <div className="card mb-3">

          <div className="card-body">

            <div className="pt-4 pb-2">
              <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
              <p className="text-center small">Enter your username & password to login</p>
            </div>

            <form className="row g-3 needs-validation" noValidate>

              <div className="col-12">
                <label htmlFor="yourUsername" className="form-label">Username</label>
                <div className="input-group has-validation">
                  <span className="input-group-text" id="inputGroupPrepend">@</span>
                  <input type="text" maxLength="35" name="username" className="form-control" id="yourUsername" value={username} onChange={(event) => setUsername(event.target.value)} required />
                  <div className="invalid-feedback">Please enter your username.</div>
                </div>
              </div>

              <div className="col-12 has-validation">
                <label htmlFor="yourPassword" className="form-label">Password</label>
                <input type={showPassword ? 'text' : 'password'} maxLength="35"name="password" className="form-control" id="yourPassword" value={password} onChange={(event) => setPassword(event.target.value)} required />
                <div className="invalid-feedback">Please enter your password!</div>
              </div>

              <div className="col-12">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe" onClick={togglePasswordVisibility} />
                  <label className="form-check-label" htmlFor="rememberMe">Show Password</label>
                </div>
              </div>
              <div className="col-12">
                <button className="btn btn-primary w-100" onClick={navigateHome} type="submit">Login</button>
              </div>              
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

</div>
    </div>
  ):window.location.replace("/home");
}

export default Login;
